import { validateToken } from 'data';

// get response from validated jwt token
export default async function getValidateToken(auth, body) {
    return validateToken(auth, body);
}
